import { createContext, useContext } from "react";

/** A two-pane pane, or the sheet drawn over both. */
export type PaneSide = "leading" | "trailing" | "sheet";

/** The two-pane pane a component renders in, or null outside the two-pane layout. */
export const PaneContext = createContext<PaneSide | null>(null);

export const usePaneSide = () => useContext(PaneContext);

/** True inside a pane headed by Home's itinerary header. */
export const PaneHeaderContext = createContext(false);

/**
 * Whether Home's itinerary header sits over this content's scroller: always outside the panes
 * (the header scrolls away over it), and inside them only where it heads the pane.
 */
export function useUnderHomeHeader(): boolean {
  const side = usePaneSide();
  const paneHeader = useContext(PaneHeaderContext);
  return side === null || paneHeader;
}
